import { dispatch } from '@@/store';
import { connect, MujiLink } from '@souche-f2e/muji';
import clazz from 'classnames';
import { Component } from 'react';
import RightContent from '../GlobalHeader/RightContent';
import BaseMenu from '../SiderMenu/BaseMenu';
import { getFlatMenuKeys } from '../SiderMenu/utils';
import styles from './index.module.less';
import UserDropdown from './userDropdown';
import React from 'react';

class TopNavHeader extends Component {
  componentWillMount() {
    dispatch.user.LOAD_USER();
  }
  render() {
    const {
      className,
      style,
      menuData,
      currentRoute,
      contentWidth,
    } = this.props;

    const flatMenuKeys = getFlatMenuKeys(menuData);

    const { name, hasUserInfoCache } = this.props;

    let routeTo = '/signIn';
    let content = '登录';

    if (hasUserInfoCache) {
      routeTo = '/personalInfo';
      content = name;
    }

    return (
      <div className={clazz(className, styles.header)} style={style}>
        <div
          className={clazz(
            styles.main,
            contentWidth === 'fixed' ? styles.wide : ''
          )}
        >
          <div className={styles.left}>
            <div className={styles.logo} key="logo" id="logo">
              <MujiLink to="/Home">
                <img width="100%" src={"https://assets-devops.oss-cn-hangzhou.aliyuncs.com/test/ac225aefe1844298d6f90712fdd90389.png"} alt="img" />
                <h1>大搜车开放平台</h1>
                <span>open.souche.com</span>
              </MujiLink>
            </div>
            <div className={styles.menu}>
              <BaseMenu
                mode="horizontal"
                flatMenuKeys={flatMenuKeys}
                currentRoute={currentRoute}
                menuData={menuData}
              />
            </div>
          </div>
          <div style={{
            width: '14em',
            textAlign: 'right'
            }}>
            {
              hasUserInfoCache ?
                <UserDropdown style={{ flex: '0 0 auto' }} name={content} /> : // 已经登录
                <RightContent className={styles.right} routeTo={routeTo} content={content} /> // 未登录
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = state.user.user || {};

  return {
    name: user.name,
    hasUserInfoCache: state.user.hasUserInfoCache
  }
}

export default connect(mapStateToProps)(TopNavHeader);
